import { TicketStatus } from 'enums';

export enum StatusFormFieldsNames {
  Status = 'status',
}

export interface StatusFormFields {
  [StatusFormFieldsNames.Status]: TicketStatus;
}
